import { CREATE_BREAKDOWN_FLOW_TEXT } from 'pages/WorkAssignments/components/CreateBreakdownFlow/texts';

import { deriveCommonRowsFromBreakdown } from './deriveCommonRowsFromBreakdown';
import { deriveCushioningRowsFromBreakdown } from './deriveCushioningRowsFromBreakdown';
import { deriveDeadheadRowsFromBreakdown } from './deriveDeadheadRowsFromBreakdown';
import { deriveParallelRideRowsFromBreakdown } from './deriveParallelRideRowsFromBreakdown';
import { derivePostIncidentDrivingRowsFromBreakdown } from './derivePostIncidentDrivingRowsFromBreakdown';
import { deriveReplacementDriverRowsFromBreakdown } from './deriveReplacementDriverRowsFromBreakdown';

const TITLES = CREATE_BREAKDOWN_FLOW_TEXT.summary.sectionTitles;

/**
 * Assemble the sections array consumed by `<BreakdownDetails />` from a raw
 * accepted `Breakdown` (GraphQL). Empty sections are dropped downstream by
 * the view; the order below covers every flow variant
 * (parallelRide / parallelRideWithCushion / busDeadhead /
 * fatigueReplacement / driverOutOfHoursReplacement) so the modal reads the
 * same as the flow's own summary step.
 *
 * @param {object} breakdown
 * @param {{ segment?: { fromStation: object, toStation: object } | null }} [options]
 *        Optional caller-resolved segment (from → to) at which the breakdown
 *        occurred. Backend does not carry this on `Breakdown`; the caller
 *        derives it from the parent `workAssignmentSequences` via
 *        `common/BreakdownDetails/deriveBreakdownSegment`.
 * @returns {import('common/BreakdownDetails').BreakdownDetailsSection[]}
 */
export const buildSectionsFromBreakdown = (breakdown, { segment } = {}) => [
	{
		id: 'common',
		title: TITLES.common,
		defaultOpen: true,
		rows: deriveCommonRowsFromBreakdown(breakdown, { segment }),
	},
	{
		id: 'deadheadInfo',
		title: TITLES.deadheadInfo,
		defaultOpen: false,
		rows: deriveDeadheadRowsFromBreakdown(breakdown),
	},
	{
		id: 'replacementDriverInfo',
		title: TITLES.replacementDriverInfo,
		defaultOpen: false,
		rows: deriveReplacementDriverRowsFromBreakdown(breakdown),
	},
	{
		id: 'parallelRide',
		title: TITLES.parallelRide,
		defaultOpen: false,
		rows: deriveParallelRideRowsFromBreakdown(breakdown),
	},
	{
		id: 'postIncidentDriving',
		title: TITLES.postIncidentDriving,
		defaultOpen: false,
		rows: derivePostIncidentDrivingRowsFromBreakdown(breakdown),
	},
	{
		id: 'cushioningParameters',
		title: TITLES.cushioningParameters,
		defaultOpen: false,
		rows: deriveCushioningRowsFromBreakdown(breakdown),
	},
];
